import React from 'react';
import { Input } from '../../../../../../components/Input';
import { S } from './Fines.styles';
import { Textarea } from '@ansvar-sakerhet/ui/src/inputs/Textarea';
import { useResultFormContext } from '../../../../components/ControlLayout';
import { Controller } from 'react-hook-form';

type Props = {
  inputLabel: string;
  klausValue: string;
  nameFine:
    | 'eplFine'
    | 'idFine'
    | 'workPermitFine'
    | 'a1Fine'
    | 'utstationeringsFine'
    | 'acceptedSubcontractorFine'
    | 'workingEnvironmentFine'
    | 'scaffoldingFine'
    | 'liftingFine'
    | 'fireSafetyFine'
    | 'sctFine'
    | 'shellProtectionFine';
  nameValue:
    | 'eplNumber'
    | 'idNumber'
    | 'workPermitNumber'
    | 'a1Number'
    | 'utstationeringsNumber'
    | 'acceptedSubcontractorNumber'
    | 'workingEnvironmentNumber'
    | 'scaffoldingNumber'
    | 'liftingNumber'
    | 'fireSafetyNumber'
    | 'sctNumber'
    | 'shellProtectionNumber';
};

export const Fines: React.FC<Props> = (props) => {
  const { control } = useResultFormContext();

  return (
    <>
      {props.klausValue === 'StandardWithValue' && (
        <>
          <Controller
            name={props.nameFine}
            control={control}
            defaultValue={0}
            render={({ field }) => (
              <Input
                {...field}
                onChange={(e) => {
                  const value = e.target.value;
                  field.onChange(Number(value));
                }}
                label={'Eget vite'}
                type="number"
              />
            )}
          />
        </>
      )}
      {(props.klausValue === 'Standard' ||
        props.klausValue === 'StandardWithValue') && (
        <Controller
          name={props.nameValue}
          control={control}
          defaultValue={0}
          render={({ field }) => (
            <Input
              {...field}
              onChange={(e) => {
                const value = e.target.value;
                field.onChange(Number(value));
              }}
              label={props.inputLabel}
              type="number"
            />
          )}
        />
      )}
      {props.klausValue === 'Own' && (
        <>
          <S.Label>Vitestext</S.Label>
          <Textarea name="Egen beskrivning" placeholder="" />
        </>
      )}
    </>
  );
};
